<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
  <span class="d-inline-flex align-items-center text-value">
    <ds-metadata-link-view [item]="item" [metadata]="metadataValue" [metadataName]="field.metadata"></ds-metadata-link-view>
  </span>
</div>
